import React, { useEffect, useState } from "react";
import { Plus, Trash2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";
import ImageUpload from "@/components/admin/ImageUpload";

export default function GalleryTab() {
  const [brand, setBrand] = useState("stamp");
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get(`/gallery?brand=${brand}`).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, [brand]);

  const newItem = () => setForm({ brand, category: "", title: "", image_url: "", is_placeholder: false, sort_order: 0 });

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...form, brand, sort_order: Number(form.sort_order) || 0 };
      if (form.id) await api.put(`/gallery/${form.id}`, payload);
      else await api.post("/gallery", payload);
      toast.success("Item salvo!");
      setForm(null);
      load();
    } catch { toast.error("Falha ao salvar"); }
    finally { setSaving(false); }
  };

  const remove = async (id) => { if (!window.confirm("Excluir item?")) return; await api.delete(`/gallery/${id}`); load(); };

  return (
    <div>
      <div className="flex justify-between items-center mb-5 flex-wrap gap-3">
        <Select value={brand} onValueChange={setBrand}>
          <SelectTrigger className="w-44 bg-[var(--bg-secondary)]" data-testid="gallery-brand-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="stamp">K8 Stamp</SelectItem><SelectItem value="sports">K8 Sports</SelectItem></SelectContent>
        </Select>
        <Button onClick={newItem} data-testid="add-gallery-button" className="btn-primary font-bold"><Plus size={16} className="mr-1" /> Novo trabalho</Button>
      </div>

      {form && (
        <div className="card-surface p-6 space-y-4 mb-6 max-w-lg">
          <ImageUpload value={form.image_url} onChange={(url) => setForm({ ...form, image_url: url })} label="Imagem do trabalho" />
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Categoria</Label><Input value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="bg-[var(--bg-secondary)]" placeholder="Camisetas, Uniformes..." /></div>
            <div><Label>Título</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="bg-[var(--bg-secondary)]" /></div>
          </div>
          <label className="flex items-center gap-2"><Switch checked={form.is_placeholder} onCheckedChange={(v) => setForm({ ...form, is_placeholder: v })} data-testid="gallery-placeholder" /> Marcar como exemplo (placeholder)</label>
          <div className="flex gap-2">
            <Button onClick={save} disabled={saving} data-testid="gallery-save" className="btn-primary font-bold flex-1">{saving ? <Loader2 className="animate-spin mr-2" size={16} /> : null} Salvar</Button>
            <Button variant="ghost" onClick={() => setForm(null)}>Cancelar</Button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((g) => (
          <div key={g.id} className="card-surface overflow-hidden" data-testid={`admin-gallery-${g.id}`}>
            <div className="aspect-square bg-[var(--bg-secondary)] overflow-hidden relative">
              {g.image_url && <img src={fileUrl(g.image_url)} alt="" className="w-full h-full object-cover" />}
              {g.is_placeholder && <span className="absolute top-2 left-2 text-[10px] bg-black/70 px-1.5 py-0.5 rounded">exemplo</span>}
            </div>
            <div className="p-3">
              <div className="text-sm font-semibold truncate">{g.title || "Sem título"}</div>
              <div className="text-xs text-[var(--text-muted)]">{g.category}</div>
              <div className="flex gap-2 mt-2">
                <Button size="sm" variant="outline" onClick={() => setForm(g)} className="border-[var(--border)] flex-1 text-xs">Editar</Button>
                <Button size="sm" variant="outline" onClick={() => remove(g.id)} className="border-[var(--border)] text-red-400"><Trash2 size={14} /></Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
